import { CreateUserPayload, GetUserDetailParam, GetUsersParams, UpdateUserPayload, usersTypes } from './types';

const getUsers = (payload: GetUsersParams, onSuccess: (...args: any[]) => void, onError: (...args: any[]) => void) => ({
  type: usersTypes.GET_USERS,
  payload,
  onSuccess,
  onError,
});

const getUserById = (
  payload: GetUserDetailParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: usersTypes.GET_USER_BY_ID,
  payload,
  onSuccess,
  onError,
});

const getCurrentProfile = (onSuccess: (...args: any[]) => void, onError: (...args: any[]) => void) => ({
  type: usersTypes.GET_CURRENT_PROFILE,
  onSuccess,
  onError,
});

const createUser = (
  payload: CreateUserPayload,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: usersTypes.CREATE_USER,
  payload,
  onSuccess,
  onError,
});

const updateUser = (
  payload: UpdateUserPayload,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: usersTypes.UPDATE_USER,
  payload,
  onSuccess,
  onError,
});

const deleteUserById = (
  payload: GetUserDetailParam,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: usersTypes.DELETE_USER,
  payload,
  onSuccess,
  onError,
});

export { getUsers, getUserById, createUser, updateUser, deleteUserById, getCurrentProfile };
